import type { SimulationDemand } from "@/models/Demand";
import type { FxValues, Offer } from "@/models/simulation/subtypes";
import type { CalculatorOfferFxAmount } from "@/types/calculator";

type GetCellAmountFxArgs = {
  offer: Offer;
  userInput: Nullable<SimulationDemand>;
  fxAmountCallback: (fxValues: FxValues, offer: Offer) => Nullable<number> | undefined;
}

/** This composable is used to get the FX utils for the calculator. */
export const useCalculatorFxUtils = () => {
  /**  Gets the cell amount FX. */
  const getCellAmountFx = ({ offer, userInput, fxAmountCallback }: GetCellAmountFxArgs): CalculatorOfferFxAmount | undefined => {
    return offer.fxValues && userInput?.currency ? {
      amount: fxAmountCallback(offer.fxValues, offer) ?? null,
      currency: userInput.currency
    } : undefined;
  };
  
  return { getCellAmountFx };
};
